import { NonEmptyArray } from "ts-essentials"
import { every, isEmpty, noop } from "lodash"
import { MultiStringOperatorType } from "./strings"

/* Validators */
function securityValidator(values: NonEmptyArray<{ indexId: string, ticker: string }>) {
  if (isEmpty(values)) {
    return false
  }
  return every(values, v => v.indexId || v.ticker)
}

interface SecurityOperator {
  label: string
  value: MultiStringOperatorType
  queryFormatter: typeof noop
  selectorType: "securitiesSearch"
  validator: typeof securityValidator
}

/* Operators */
export const SECURITIES_OPERATORS: NonEmptyArray<SecurityOperator> = [{
  label: "is in",
  value: "in",
  queryFormatter: noop,
  selectorType: "securitiesSearch",
  validator: securityValidator,
}, {
  label: "is not in",
  value: "notIn",
  queryFormatter: noop,
  selectorType: "securitiesSearch",
  validator: securityValidator,
}] as const
